import React from "react";
import { AlertCircle } from "lucide-react";
import { Button } from "../../../components/ui/button";

interface RepositoryErrorStateProps {
  message: string;
  onRetry: () => void;
}

const RepositoryErrorState = ({ message, onRetry }: RepositoryErrorStateProps) => {
  return (
    <div className="flex min-h-[220px] flex-col items-center justify-center gap-3 rounded-md border border-dashed text-center">
      <AlertCircle className="h-5 w-5 text-red-500" />
      <p className="text-sm font-medium">Could not load repositories</p>
      <p className="max-w-md text-xs text-muted-foreground">{message}</p>
      <Button variant="outline" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
};

export default RepositoryErrorState;
